export const firebaseConfig = {
  apiKey: 'AIzaSyBdKCosB3mL7iBQfp7Bgx6YKn9wzDmD5B0',
  authDomain: 'starting-eleven-2019.firebaseapp.com',
  databaseURL: 'https://starting-eleven-2019.firebaseio.com',
  projectId: 'starting-eleven-2019',
  storageBucket: 'starting-eleven-2019.appspot.com',
  messagingSenderId: '506628955022',

  //public static googleMapsApiKey = "'AIzaSyCE0TefdtF_NTC1kgl5PnD7jj9qPdsD6bA'"
  googleMapsApiKey: "'AIzaSyCS9As7VIoLzcgTxz00SgEBuIv8JZOKZGI'",
};
